module.exports = new __parcel__URL__("ideas-dark.12116060.svg").toString();